import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
} from '@angular/core';

import { IrisBaseModalComponent } from '../base-modal/base-modal.component';
import { IrisModalRef } from '../utilities/modal-ref';

@Component({
  selector: 'iris-full-screen-modal',
  templateUrl: './full-screen-modal.component.html',
  styleUrls: ['./full-screen-modal.component.scss']
})
export class IrisFullScreenModalComponent<TContent, TModalInputs, TResponseData>
  extends IrisBaseModalComponent<TContent, TModalInputs, TResponseData>
  implements OnInit, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(
    focusTrapFactory: ConfigurableFocusTrapFactory,
    hostElement: ElementRef,
    ref: IrisModalRef<TContent, TModalInputs, TResponseData>
  ) {
    super(focusTrapFactory, hostElement, ref);
  }

  ngOnInit(): void {
    this.initializeModalContent();
  }
}
